import React from "react";
import UserTable from "../Components/user/UserTable";
import Maps from "../Components/user/Map";
import Navbar from "../Components/Navbar";
import UserTablePagination from "../Components/user/UserTablePagination";

function User(props) {
  return (
    <div className="relative flex flex-col">
      <Navbar />
      {/* <div className="grow w-full flex flex-col"> */}
        <UserTable />
        <UserTablePagination/>
        <Maps />
      {/* </div> */}
    </div>
  );
}

export default User;
